const { createAction } = require('../helpers')
const {
  POST_CHAT_DATA,
  POST_CHAT_DATA_SUCCESS,
  POST_CHAT_DATA_ERROR,
  POST_CHAT_DATA_RESET,
  GET_CHAT_DATA,
  GET_CHAT_DATA_SUCCESS,
  GET_CHAT_DATA_ERROR,
  GET_CHAT_DATA_RESET,
} = require('./constants')

const postChatData = ({ data, id }) => createAction(POST_CHAT_DATA, { data, id })
const postChatDataSuccess = data => createAction(POST_CHAT_DATA_SUCCESS, { data })
const postChatDataError = error => createAction(POST_CHAT_DATA_ERROR, { error })
const postChatDataReset = () => createAction(POST_CHAT_DATA_RESET)

const getChatData = id => createAction(GET_CHAT_DATA, { id })
const getChatDataSuccess = data => createAction(GET_CHAT_DATA_SUCCESS, { data })
const getChatDataError = error => createAction(GET_CHAT_DATA_ERROR, { error })
const getChatDataReset = () => createAction(GET_CHAT_DATA_RESET)

module.exports = {
  postChatData,
  postChatDataSuccess,
  postChatDataError,
  postChatDataReset,
  getChatData,
  getChatDataSuccess,
  getChatDataError,
  getChatDataReset,
}
